module.exports = __webpack_public_path__ + "static/media/carfix.07723687.png";